import React from 'react'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

// a phone number formatter that supports 10 digit
// phone numbers, formatting them in accordance with Ameriprise
// practices (https://www.ameriprise.com/customer-service/contact)
const PhoneNumber = props => {
  let numericString = !isNaN(Number(props.phoneNumber))

  // eg 6121119999
  let tenDigit = props.phoneNumber.length === 10

  if (numericString && tenDigit) {
    // This will convert 6121119999 --> 612.111.9999
    let formattedValue = `${props.phoneNumber.slice(0, 3)}.${props.phoneNumber.slice(
      3,
      6
    )}.${props.phoneNumber.slice(6)}`
    return <span className='u-textColorLight'>{formattedValue}</span>
  } else {
    return <span className='u-textColorLight'>{props.phoneNumber}</span>
  }
}

const PresenterInfo = () => {
  const results = localStorage.getItem('results')

  let resultsParsed = JSON.parse(results)

  return (
    <>
      {resultsParsed && (
        <div className='welcome-presenter-info-container u-paddingHoriz6gu u-bgColorWhite u-flex'>
          <div className='welcome-presenter-info-image-wrap'>
            {resultsParsed.profilesmallimage && (
              <img
                src={sanitizeHTML(resultsParsed.profilesmallimage)}
                alt={resultsParsed.displayname}
              />
            )}
          </div>
          <div className='welcome-presenter-info-text u-paddingLeft6gu u-paddingTop9gu'>
            {resultsParsed.displayname && (
              <h2 className='u-textSizeMsrp2 u-textColorBrand u-marginBottom3gu'>
                {resultsParsed.displayname}
              </h2>
            )}

            <p className='u-textColorLight'>
              {resultsParsed.phonenumber ? (
                <PhoneNumber phoneNumber={resultsParsed.phonenumber} />
              ) : (
                ''
              )}
              {resultsParsed.phonenumber && resultsParsed.email ? ' | ' : ''}
              {resultsParsed.email ? resultsParsed.email : ''}
            </p>
          </div>
        </div>
      )}
    </>
  )
}

export default PresenterInfo
